import React from 'react';
import { IModGroupChildItem, IModifierForAssign, RestaurantModGroupPropertiesType } from 'types';
import { MultipleSelect } from './MultipleSelect';
import { ModifierFromTemplate } from './ModifierFromTemplate';
import { Modifier } from './Modifier';
import style from './ModifiersList.module.scss';

interface IProps {
	setChildren: (value: IModGroupChildItem[]) => void;
	refetch: () => void;
	responseError: boolean;
	IDsSelectedModifiers: string[];
	availableModifiers: IModifierForAssign[];
	selectedChildren: IModGroupChildItem[];
}

export const ModifiersList: React.FC<IProps> = React.memo(
	({ setChildren, refetch, responseError, IDsSelectedModifiers, availableModifiers, selectedChildren }) => {
		const handleSetModifiers = (value: string[]) => {
			const updatedChildren = value.map((modifierId) => {
				const childFromPreviousState = selectedChildren.find((exist) => exist.id === modifierId);

				if (childFromPreviousState) {
					return childFromPreviousState;
				}

				const fetchedModifier = availableModifiers.find((modifier) => modifier.id === modifierId);
				const newChild: IModGroupChildItem = {
					id: modifierId,
					name: fetchedModifier?.name || '-',
					externalId: '',
					isDefault: fetchedModifier?.isDefault || false,
					type: RestaurantModGroupPropertiesType.Modifier,
					isFromTemplate: fetchedModifier?.isFromTemplate || false,
				};
				return newChild;
			});
			const sortedChildren = [...updatedChildren].sort((a, b) => {
				if (a.isFromTemplate === b.isFromTemplate) {
					return 0;
				}
				return a.isFromTemplate ? -1 : 1;
			});

			setChildren(sortedChildren);
		};

		const handleRemove = (id: string) => {
			const updatedChildren = selectedChildren.filter((child) => child.id !== id);
			setChildren(updatedChildren);
		};

		return (
			<div className={style.container} data-test="ModifiersList">
				<MultipleSelect
					data={availableModifiers || []}
					refetch={refetch}
					responseError={responseError}
					setModifiers={handleSetModifiers}
					IDsSelectedModifiers={IDsSelectedModifiers}
				/>
				<div className={style.groupsList}>
					{selectedChildren.map((el, index) =>
						el.isFromTemplate ? (
							<ModifierFromTemplate
								key={el.id}
								onDelete={handleRemove}
								positionNumber={index + 1}
								label={el.name || '-'}
								modifierId={el.id}
								isDefault={el.isDefault}
							/>
						) : (
							<Modifier
								key={el.id}
								onDelete={handleRemove}
								positionNumber={index + 1}
								label={el.name || '-'}
								modifierId={el.id}
								isDefault={el.isDefault}
							/>
						),
					)}
				</div>
			</div>
		);
	},
);
